import React, { useState } from "react";
import { Box, VStack, HStack, Text, Button, Image } from "@chakra-ui/react";
import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import TextBoxImg from "assets/svg/text_box.svg";
import StarsImg from "assets/svg/stars.svg";
import GroupLogo from "assets/svg/Group.svg";
import AuthBox from "../../../auth/helper/AuthBox";

const GRADIENT =
  "conic-gradient(from 180deg at 50% 50%, #FF98E2 0deg, #FFC876 35.77deg, #79FFF7 153.75deg, #9F53FF 258.75deg, #FF98E2 360deg)";
const gradientText = { bgImage: GRADIENT, bgClip: "text", WebkitBackgroundClip: "text", color: "transparent" };

export default function LandingPage() {
  const [showAuth, setShowAuth] = useState(false);
  return (
    <Box pos="fixed" inset="0" bg="#0E0C15" overflow="hidden">
      <Image src={GroupLogo} alt="logo" pos="relative" zIndex={2} transform={{ base: "translate(30%, 50%)", md:   "translate(40%, 60%)", }} w="100px" />
      
      <Box 
        display={{ base: "none", md: "block" }}  
        pos="absolute" 
        top="50%"
        left="50%"
        transform="translate(-90%,-50%)"
        w="598px"
        h="570px"
      >
        <Box pos="absolute" top={0} left={0} w="100%" h="100%" bgImage="linear-gradient(to bottom right, #4400FF 0%, #AA00FF 60%, transparent 100%)" filter="blur(40px)" transform="translate(-20px,20px)" zIndex={-1}/>        
        <Image src={TextBoxImg} alt="Text Box" w="100%" h="100%" objectFit="cover"/>
        <Image 
          src={StarsImg} 
          alt="Stars" 
          pos="absolute" 
          top="0.9%" 
          left="8.4%" 
          w="78.3%" 
          h="81.2%" 
          objectFit="cover"
        />
      </Box>
      
      <VStack 
        pos="absolute" 
        top="50%"  
        left={{ base: "50%", md: "75%" }}
        transform="translate(-50%,-50%)" 
        align={{ base: "center", md: "flex-start" }}  
        spacing={2} 
        w={{ base: "90%", md: "576px" }}
      >
        <HStack spacing={2}>
          <Text fontSize="12px" letterSpacing="15%" textTransform="uppercase" sx={gradientText}>[</Text>
          <Text fontFamily="Inter" fontWeight="400" fontSize="12px" letterSpacing="15%" textTransform="uppercase" color="#ADA8C3">GRID AI</Text>
          <Text fontSize="12px" letterSpacing="15%" textTransform="uppercase" sx={gradientText}>]</Text>
        </HStack>
        <Text 
          fontFamily="Inter" 
          fontWeight="400" 
          fontSize={{ base: "24px", md: "35px" }} 
          lineHeight={{ base: "36px", md: "60px" }} 
          color="white"
          textAlign={{ base: "center", md: "left" }} 
        >
          Connect with GRID AI
        </Text>
        <Text 
          fontFamily="Inter" 
          fontWeight="400" 
          fontSize={{ base: "14px", md: "16px" }} 
          lineHeight={{ base: "20px", md: "24px" }} 
          color="#ADA8C3"
          textAlign={{ base: "center", md: "left" }} 
        >
          Your intelligent assistant for esports and travel. Get help with tournament management, game strategies, travel planning, destination guides, and more.
        </Text>
        <Box h="40px"/>
        <Button 
          cursor="pointer" 
          w="276px" 
          h="56px" 
          border="1px solid #8d5991" 
          color="#8d5991" 
          bg="transparent" 
          borderRadius="8px" 
          fontSize="18px" 
          onClick={() => setShowAuth(true)}
        >
          Get Started
        </Button>
      </VStack>
      {showAuth && (
        <Box pos="fixed" inset="0" zIndex={5} bg="rgba(0,0,0,0.4)" onClick={() => setShowAuth(false)}>
          <Box pos="absolute" top="50%" left="50%" transform="translate(-50%,-50%)" onClick={e => e.stopPropagation()}>
            <AuthBox/>
          </Box>
        </Box>
      )}
    </Box>
  );
}